/*
 * @LastEditTime: 2025-12-29 14:41:35
 * @FilePath: /mall-fe/src/comps/Footer.cscec3b.tsx
 * @Description: 商城新版首页底部组件,被多个工程通过iframe形式引用
 *
 */
/* eslint-disable react/jsx-no-target-blank */
// @ts-nocheck
import Container from 'comps/Container';
import useUrl from 'hooks/useUrl';
import ImgDriverQRNew from 'images/cscec3b/driver-qr-new';
// import ImgPurQRNew from 'images/cscec3b/purchaser-qr-new';
// import ImgSupQRNew from 'images/cscec3b/supplier-qr-new';
import ImgCompanyQR from 'images/cscec3b/mini-program-company-qr.png';
import ImgPersonalQR from 'images/cscec3b/mini-program-personal-qr.png';
import { DeviceContext, NavConfigContext, UserContext } from 'libs/contexts';
import { useContext, useEffect, useState } from 'react';
import { getSmartSettlementAuthCode } from 'api/user';
import css from 'styled-jsx/css';
import { HELP_CENTER_URL_PREFIX } from 'libs/urls';
import { getMallDataConfigList } from '@/api/mall';
import FooterBg from '@/images/cscec3b/home/footer-bg.png';
// import FooterIconA from '@/icons/home/footer1.svg';
// import FooterIconB from '@/icons/home/footer2.svg';
// import FooterIconC from '@/icons/home/footer3.svg';
// import FooterIconD from '@/icons/home/footer4.svg';

// 站点底部入口组件
export default function Footer() {
  const userInfo = useContext(UserContext);
  // 跳转至帮助中心逻辑
  const gotoHelpCenter = async () => {
    let linkUrl = `${HELP_CENTER_URL_PREFIX}/helpCenterJumpPage?code=`;
    if (userInfo && userInfo.name) {
      const { data = {} } = await getSmartSettlementAuthCode('cscec3_yun_cai');
      linkUrl = `${linkUrl}${data?.authCode || ''}`;
    }
    window.selfOpen(linkUrl, '_blank');
  };
  // @ts-ignore
  return <NewFooterPC toHelpCenter={gotoHelpCenter} />;
}

const containerStyles = css`
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px 0;
    border-bottom: 1px solid #DDE2E9;
  }
  .container:before,
  .container:after {
    display: none;
  }
`;

const NewFooterPC = (props) => {
  // 获取站点导航配置信息
  const navConfig = useContext(NavConfigContext);
  // 构建oss静态资源的访问路径
  const { buildImgSrc } = useContext(DeviceContext);
  // 获取静态资源公共前缀
  const { getPublicUrl } = useUrl();
  const [configList, setConfigList] = useState<any>([]);

  useEffect(() => {
    getMallDataConfigList().then((res) => {
      setConfigList(res?.data || []);
    });
  }, []);

  return (
    <div className="footer-wrap">
      <div className="footer">
        <div className="tip-list">
          {configList?.length > 0
            ? configList.map((item, index) => {
                return (
                  <div className="tip-item" key={index}>
                    <img src={buildImgSrc(getPublicUrl(item.icon))} alt="" />
                    <span>{item.description}</span>
                  </div>
                );
              })
            : null}
          {/* <div className="tip-item">
            <FooterIconA style={{ width: '48px', height: '48px' }} />
            <span style={{ marginLeft: '6px' }}>31 个省、直辖区及自治区</span>
          </div>
          <div className="tip-item">
            <FooterIconB style={{ width: '48px', height: '48px' }} />
            <span style={{ marginLeft: '6px' }}>1600+ 品类</span>
          </div>
          <div className="tip-item">
            <FooterIconC style={{ width: '48px', height: '48px' }} />
            <span style={{ marginLeft: '6px' }}>3700+ 家供应商</span>
          </div>
          <div className="tip-item">
            <FooterIconD style={{ width: '48px', height: '48px' }} />
            <span style={{ marginLeft: '6px' }}>100万+ 个SKU</span>
          </div> */}
        </div>
        <Container styles={containerStyles}>
          <div className="left">
            {navConfig?.logo?.[0]?.imageUrl ? (
              <img
                className="logo"
                src={buildImgSrc(getPublicUrl(navConfig?.logo?.[0]?.imageUrl))}
                alt="logo"
              />
            ) : (
              <div className="logo-placeholder" />
            )}
            <p className="unit">主办单位：中建三局集团有限公司</p>
            <p>
              官方邮件：
              <a href="mailto:ycgyl-kf@cscec.com" title="ycgyl-kf@cscec.com">
                ycgyl-kf@cscec.com
              </a>
            </p>
          </div>
          <div className="right">
            <div className="qrs">
              <div className="qr">
                <img className="qr-img" src={ImgCompanyQR} alt="三局严选二维码" />
                <div className="qr-text">三局严选</div>
              </div>
              <div className="qr">
                <img className="qr-img" src={ImgPersonalQR} alt="严选优服二维码" />
                <div className="qr-text">严选优服</div>
              </div>
              <div className="qr">
                <img className="qr-img" src={ImgDriverQRNew} alt="严选物流APP二维码" />
                <div className="qr-text">严选物流APP</div>
              </div>
            </div>
            <div className="contact">
              <div className="tel">0711-5900818</div>
              <a className="help-center" title="帮助中心" onClick={props.toHelpCenter}>
                <i className="iconfont icon-question1" />
                帮助中心
              </a>
            </div>
          </div>
        </Container>
      </div>
      <div className="copyright">
        <div>
          &copy;2022 中建三局云采供应链有限公司. 保留所有权利. ICP备案号： 鄂ICP备2022004257号-2
          ，增值电信许可证：鄂B2-20220325
        </div>
        <div style={{ marginTop: '8px' }}>鄂公网安备 42070302000127号</div>
      </div>
      <style jsx>{`
        .footer-wrap {
          padding: 32px;
          background-color: #fff;
          background-image: url(${FooterBg});
          background-size: cover;
        }
        .footer {
          color: #333;
          font-size: 14px;
        }
        .left p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 0px;
        }
        .left .unit {
          margin: 37px 0 6px 0;
        }
        .left p a {
          color: #333;
        }
        .left p a:hover {
          color: var(--primaryColor);
        }
				.left .logo {
					width: auto;
					height: 30px;
				}
				.logo-placeholder {
					width: 159px;
					height: 30px;
					background-color: #f6f6f6;
				}
        .right {
          display: flex;
        }
        .qrs {
          display: flex;
          padding-right: 42px;
        }
        .qr {
          margin-left: 24px;
        }
        .qr-img {
          width: 84px;
          height: 84px;
          padding: 10px;
          background-color: #fff;
        }
        .qr-text {
          font-size: 14px;
          line-height: 20px;
          margin-top: 8px;
          text-align: center;
        }
				.contact {
          padding-left: 42px;
          border-left: 1px solid #DDE2E9;
					color: #333;
          text-align: center;
				}
				.contact .tel {
					font-size: 24px;
					line-height: 32px;
				}
				.contact .tip {
					font-size: 12px;
					line-height: 16px;
					margin: 5px 0 17px 0;
				}
				.contact .help-center {
					width: 170px;
					height: 34px;
					background: #191919;
					border-radius: 17px;
					display: flex;
					font-size: 12px;
          justify-content: center;
          align-items: center;
          color: #fff;
          line-height: 16px;
          margin: 17px auto 0;
				}
        .help-center .icon-question1 {
          margin-right: 8px;
        }
        .copyright {
          padding-top: 24px;
          font-size: 14px;
          line-height: 20px;
          color: #525960;
          text-align: center;
        }
        .tip-list {
          display: flex;
          width: 1200px;
          margin: 0 auto;
          justify-content: space-between;
          padding: 24px 0;
          border-bottom: 1px solid #DDE2E9;
          margin-bottom: 24px;
        }
        .tip-item {
          font-size: 16px;
          line-height: 26px;
          display: flex;
          align-items: center;
          color: #000;
        }
        .tip-item img {
          width: 48px;
          height: 48px;
          margin-right: 6px;
        }
        .line {
          width: 1px;
          height: 24px;
          background-color: #EBEAEA;
        }
      `}</style>
    </div>
  );
};
